import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import { v4 as uuid } from "uuid";
import TestSeriesTableElement from "./TestSeriesTableElement";
import TestSeriesWhiteChipTableElement from "./TestSeriesWhiteChipTableElement";
import ConditionSection from "../../../../../../api/models/test-series/ConditionSection";
import MeasurementSection from "../../../../../../api/models/test-series/MeasurementSection";
import ParameterValueGroup from "../../../../../../api/models/test-series/ParameterValueGroup";
import { TestSeriesContext } from "../../../../../../contexts/TestSeriesContext";
import HeadlineAddButton from "./HeadlineAddButton";

const useStyles = makeStyles({
  tableCell: {
    border: "1px solid",
    borderColor: "#ECECED",
    verticalAlign: "top",
  },
  listAddButton: {
    padding: 0,
    paddingTop: 10,
    paddingBottom: 10,
  },
  cellHeadline2: {
    color: "#757575",
    fontSize: "0.9rem",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
});

interface TestSeriesMeasurementColumnProps {
  enabled: boolean;
  validated: boolean;
  condition: ConditionSection;
  updateCondition: (condition: ConditionSection) => void;
  measurement: MeasurementSection;
  updateMeasurement: (measurement: MeasurementSection) => void;
}

const TestSeriesMeasurementColumn: React.FunctionComponent<TestSeriesMeasurementColumnProps> = (props) => {
  const classes = useStyles();
  const { enabled, condition, updateCondition, measurement, updateMeasurement, validated } = props;
  const { showTextDialog } = useContext(TestSeriesContext);

  function handleAddCondition(newCondition: ParameterValueGroup): void {
    condition.conditions.push(newCondition);
    // trigger rerender through state update
    updateCondition({ ...condition });
  }

  function handleDeleteCondition(i: number): void {
    const newArray = [...condition.conditions];
    newArray.splice(i, 1);
    condition.conditions = newArray;
    updateCondition({ ...condition });
  }

  return (
    <TableCell align="left" className={classes.tableCell}>
      <HeadlineAddButton
        title="Condition"
        enabled={enabled}
        onClick={(): void => {
          showTextDialog("Flow Name", undefined, "Name")
            .then((name) => {
              handleAddCondition({
                name,
                parameterValues: [],
              });
            })
            .catch(() => {
              // do nothing
            });
        }}
      />
      {condition.conditions &&
        condition.conditions.map((e: ParameterValueGroup, i: number) => {
          return (
            <span key={uuid()}>
              <TestSeriesTableElement
                enabled={enabled}
                validated={validated}
                section="condition"
                parametersInAllTests={condition.parametersInAllTests}
                primaryChip={e.name}
                secondaryChips={e.parameterValues}
                onRenamePrimary={(newName): void => {
                  e.name = newName;
                  updateMeasurement({ ...measurement });
                }}
                onPrimaryChipDelete={(): void => {
                  handleDeleteCondition(i);
                }}
                updateParentState={(): void => {
                  updateMeasurement({ ...measurement });
                }}
              />
            </span>
          );
        })}
      <div className={classes.cellHeadline2}>Parameters in all Tests</div>
      <TestSeriesWhiteChipTableElement
        enabled={enabled}
        validated={validated}
        section="condition"
        conditions={condition.conditions}
        chips={condition.parametersInAllTests}
        updateParentState={(): void => {
          updateCondition({ ...condition });
        }}
      />

      <div className={classes.listAddButton}>
        <b>Properties</b>
      </div>
      <TestSeriesWhiteChipTableElement
        enabled={enabled}
        validated={validated}
        section="measurement"
        chips={measurement.measurements}
        updateParentState={(): void => {
          updateMeasurement({ ...measurement });
        }}
      />
    </TableCell>
  );
};
export default TestSeriesMeasurementColumn;
